//HTML em resources\views\components\layout\cfp-toasts.blade.php

function exibirElementoToast(elementoToast, msg){
	let elementoToastText = elementoToast.querySelector('.toast-text');
	elementoToastText.innerHTML = msg;
	const toastBootstrap = window.bootstrap.Toast.getOrCreateInstance(elementoToast)
	toastBootstrap.show();
}

window.addEventListener('exibirJsAlert', function(event){
	window.toastInfo(event.detail.msg);
});
window.addEventListener('toastInfo', function(event){
	window.toastInfo(event.detail.msg);
});
window.addEventListener('toastSucesso', function(event){
	window.toastSucesso(event.detail.msg);
});
window.addEventListener('toastErro', function(event){
	window.toastErro(event.detail.msg);
});
window.addEventListener('toastAlerta', function(event){
	window.toastAlerta(event.detail.msg);
});

window.toastSucesso = function(msg){
	let elementoToast = document.getElementById('liveToast-sucesso');
	exibirElementoToast(elementoToast, msg);
};

window.toastInfo = function(msg){
	let elementoToast = document.getElementById('liveToast-info');
	exibirElementoToast(elementoToast, msg);
};

window.toastErro = function(msg){
	let elementoToast = document.getElementById('liveToast-erro');
	exibirElementoToast(elementoToast, msg);
};

window.toastAlerta = function(msg){
	let elementoToast = document.getElementById('liveToast-alerta');
	exibirElementoToast(elementoToast, msg);
};
